import React, { Component } from 'react';

import {Cam, Text} from './shared/Icons';
import AppDownload from './AppDownload';
import Paper from '@material-ui/core/Paper';
import MetadataField from './shared/MetadataField';
import Button from '@material-ui/core/Button';

import { intlShape, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
class Metadata extends Component {

  static contextTypes = {
    intl: intlShape.isRequired,
  }

  setLocale(lang) {
    if (window.localStorage) {
      window.localStorage.setItem('language', lang);
      window.location.reload();
    }
  }

  render() {
    const { locale, user, onMetadataChanged, metadata, metadataConfig, getLogo } = this.props;
    const inputMetadata = metadataConfig.map(m => {
      return <MetadataField
        key={m.id}
        field={m}
        config={metadataConfig}
        values={metadata[m.id]}
        onChange={(v) => onMetadataChanged(Object.assign({}, metadata, {[m.id]: v}))}
      />
    });

    return (
      <Paper elevation={5} className="metadataForm">
        <form action="" onSubmit={(e) => { e.preventDefault(); this.props.onSubmit() }}>
          <p>
            <FormattedMessage
              id='metadata.FillOut'
              defaultMessage='Um die Verbindung zu starten, füllen Sie bitte die folgenden Angaben aus. Ihre Daten werden verschlüsselt und Peer-to-Peer an Ihren Arzt übermittelt.'
            />
            <br/>
            <FormattedMessage
              id='metadata.Confidential'
              defaultMessage='Es findet keine Speicherung oder Übermittlung der Daten an Dritte statt.'
            />
          </p>
          {inputMetadata}
          <div style={{textAlign:'right'}}>
            <Button type="submit" className="metadataSubmitButton" variant="contained" color="primary">
              <FormattedMessage
                id='metadata.Submit'
                defaultMessage='Verbinden'
              />
            </Button>
          </div>
        </form>
      </Paper>
    )
  }
};

export default Metadata;


// WEBPACK FOOTER //
// ./src/Metadata.js